import './index.less';
import { observer } from 'mobx-react';
import React from 'react';
import {
	DashboardTreeStore,
	bDbTree,
} from 'areas/dashboards/pages/DashboardsPage/components/DashboardsTree/dashboardTreeStore';
import { useStore } from 'core/react/useStore';
import { AntTree } from 'controls/react/ant/antTree';
import { FolderOpenOutlined, FolderOutlined } from '@ant-design/icons';
import { AntTreeNodeProps } from 'antd/es/tree/Tree';
import { Section } from 'controls/react/layout/section';
import { GridStore } from 'controls/grid/gridStore';
import { DashboardsListEntry } from 'areas/dashboards/DashboardsGridStore/types';

export type DashboardsTreeSettings = {
	hideLeafs?: boolean;
	disableDragAndDrop?: boolean;
	disableDelete?: boolean;
};

export type DashboardsTreeProps = {
	gridStore: GridStore<DashboardsListEntry>;
	onSelect?: (path: string) => void;
	settings?: DashboardsTreeSettings;
};

export const DashboardsTree = observer((props: DashboardsTreeProps) => {
	const store = useStore(() => new DashboardTreeStore(props));

	return (
		<Section
			appearance={'none'}
			contentPadding={false}
			containerClass={bDbTree()}
			contentOverlay={store.loading}
			overlaySpinner={store.loading}
		>
			{store.notEmpty && (
				<AntTree
					componentRef={(ref) => (store.treeComponent = ref)}
					switcherIcon={(props: AntTreeNodeProps) => <SwitcherIcon {...props} />}
					draggable={store.draggableSettings}
					blockNode
					expandedKeys={store.expandedKeys}
					onExpand={store.onExpand}
					onDrop={store.onDrop}
					treeData={store.dashboardsTree}
					titleRender={store.titleRender}
					onClick={store.onFolderSelected}
				/>
			)}
		</Section>
	);
});

const SwitcherIcon = observer((antProps: AntTreeNodeProps) => {
	return (
		<>
			{!antProps.expanded && <FolderOutlined />}
			{antProps.expanded && <FolderOpenOutlined />}
		</>
	);
});
